export declare let builtinPlugins: any;
export declare const initPlugins: () => void;
